import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useAuth } from "react-oidc-context";
import { getUserId } from "utils/getUserId";
import { convertToLetters } from "utils/convertToLetters";
import Avatar from "components/Avatar";
import Chip from "components/Chip";

const CreatedForCell: FC<Props> = ({ element }) => {
  const auth = useAuth();
  const userId = getUserId(auth.user!);

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.stack}`}>
        <div className={styles.sender}>
          {userId !== element.UserId && (
            <Chip
              small
              key={element.UserId}
              avatar={
                <Avatar className={styles.avatar}>
                  {convertToLetters(element.UserLabel)}
                </Avatar>
              }
              element={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  {element.UserLabel}
                </div>
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CreatedForCell;
